// -----------------------------
// FORMATTERS
// -----------------------------

export const formatNumberSmart = (value) => {
  if (isNaN(value)) return "";

  if (Number.isInteger(value)) {
    return value.toString();
  }

  return value
    .toFixed(2)
    .replace(".", ",")
    .replace(/,?0+$/, "");
};

export const formatEuro = (value) => {
  if (isNaN(value)) return "";

  const rounded = Math.round(value);
  return `${rounded.toLocaleString("fi-FI")} €`;
};

// -----------------------------
// PARSER
// -----------------------------

export const parseFinnishNumber = (value) => {
  if (value == null) return NaN;

  if (typeof value === "number") return value;

  return Number(
    value
      .toString()
      .replace(/\u00A0/g, "")
      .replace(/\s/g, "")
      .replace("€", "")
      .replace(",", ".")
  );
};

// -----------------------------
// DIFFERENCE (%)
// -----------------------------

export const calculateDifference = (value, reference) => {
  const v = parseFinnishNumber(value);
  const r = parseFinnishNumber(reference);

  if (isNaN(v) || isNaN(r) || r === 0) return "";

  const diff = ((v - r) / r) * 100;

  // 🔥 pyöristys 1 desimaaliin
  const rounded = Math.round(diff * 10) / 10;

  // 🔥 suomalainen muotoilu + poista ,0
  return `${rounded
    .toString()
    .replace(".", ",")
    .replace(",0", "")} %`;
};
// -----------------------------
// AUTO DETECT KEYS
// -----------------------------

const findOminaiskulutusKey = (columns) =>
  columns.find(
    (c) =>
      c.toLowerCase().includes("ominaiskulutus") &&
      !c.toLowerCase().includes("vertailuarvo")
  );

const findVertailuKey = (columns) =>
  columns.find((c) =>
    c.toLowerCase().includes("vertailuarvo")
  );

// -----------------------------
// APPLY DIFFERENCE TO ROW
// -----------------------------

export const applyDifferenceToRow = (row, columns) => {
  if (!columns.includes("Erotus")) return row;

  const ominaisKey = findOminaiskulutusKey(columns);
  const vertailuKey = findVertailuKey(columns);

  if (!ominaisKey || !vertailuKey) return row;

  return {
    ...row,
    Erotus: calculateDifference(
      row[ominaisKey],
      row[vertailuKey]
    ),
  };
};

// -----------------------------
// APPLY DIFFERENCE TO ALL ROWS
// -----------------------------

export const applyDifferenceToRows = (rows, columns) => {
  return rows.map((row) => applyDifferenceToRow(row, columns));
};

// -----------------------------
// BUILD AVERAGE ROW
// -----------------------------

export const buildAverageRow = (columns, rows) => {
  if (!rows || rows.length === 0) return null;

  const avgRow = {};

  // --- NORMAL AVERAGES ---
  columns.forEach((col, idx) => {
    if (idx === 0) {
      avgRow[col] = "Keskiarvo";
      return;
    }

    if (col === "Erotus") return;

    const values = rows
      .map((r) => parseFinnishNumber(r[col]))
      .filter((v) => !isNaN(v));

    if (values.length === 0) {
      avgRow[col] = "";
      return;
    }

    const avg =
      values.reduce((a, b) => a + b, 0) / values.length;

    const isEuroColumn = col.includes("€");

    avgRow[col] = isEuroColumn
      ? formatEuro(avg)
      : formatNumberSmart(avg);
  });

  // --- CALCULATE DIFFERENCE FROM AVERAGES ---
  if (columns.includes("Erotus")) {
    const ominaisKey = findOminaiskulutusKey(columns);
    const vertailuKey = findVertailuKey(columns);

    if (ominaisKey && vertailuKey) {
      avgRow["Erotus"] = calculateDifference(
        avgRow[ominaisKey],
        avgRow[vertailuKey]
      );
    }
  }

  return avgRow;
};